import React from 'react'
import { helpers } from "services/index";
import useTranslation from "hooks/useTranslation";
import { Settings, ShoppingBag, Car, KeyRound, Warehouse, Shield, MessageSquare, User, Lock, Printer, Edit, CreditCard, Image, History, CircleDollarSign, HandCoins, Bot } from "lucide-react";
import classNames from "classnames";
import { Fields } from "uicomponents";
import { get } from "lodash";

const OtherSetings = ({ values, setFieldValue }) => {
  const { tr } = useTranslation();
  return (
    <div>
      <>
        {[
          {
            title: tr("Тип заказа"),
            children: helpers
              .orderTypes(tr)
              .map(orderType => ({
                id: orderType.value,
                label: orderType.label,
                icon: (() => {
                  if (orderType.value === "has_telegram_bot")
                    return Bot;
                  if (orderType.value === "has_takeaway")
                    return ShoppingBag;
                  if (orderType.value === "has_delivery")
                    return Car;
                })(),
                description: ""
              }))
          },
          {
            title: tr("Другие параметры"),
            children: [
              {
                id: "show_passkey_for_change_waiter",
                label: tr(
                  "Показать пароль при смене Агента"
                ),
                icon: KeyRound,
                description:
                  tr("При включении для смены Агента потребуется пароль")
              },
              {
                id: "storage_enabled",
                label: tr("Работа со склада"),
                icon: Warehouse,
                description:
                  tr("При отключении, склад будет отключена, торговля товарами будет осуществляться без учета доходов и расходов.")
              },
              {
                id: "stock_control",
                label: tr("По остаткам на складе"),
                icon: Warehouse,
                description:
                  tr("При включении, продажи будут осуществляться с остатком на складе")
              },
              {
                id: "show_passkey_for_return_order",
                label: tr(
                  "Показать пароль при восстановлении заказа"
                ),
                icon: Shield,
                description:
                  tr("При включении для восстановления заказа потребуется пароль")
              },
              {
                id: "add_comment_remove_dish",
                label: tr(
                  "Добавить комментарий при удаления продуктов"
                ),
                icon: MessageSquare,
                description:
                  tr("При включении при удалении блюд потребуется комментарий")
              },
              {
                id: "has_rfid",
                label: tr(
                  "Авторизация сотрудников с помощью «ID» карт"
                ),
                icon: User,
                description:
                  tr("При включении все пользователи должны иметь при себе карту «ID», и все остальные действия, требующие пароля, будут авторизованы с ее помощью.")
              },
              {
                id: "show_passkey_for_remove_dish",
                label: tr("Пароль при отмене продукт"),
                icon: Lock,
                description:
                  tr("При включении для отмены продукт потребуется пароль")
              },
              {
                id: "show_passkey_for_return_order_item",
                label: tr("Пароль, используемый для возврата товара в заказе"),
                icon: Lock,
                description:
                  tr("При включении, для возврата товара в заказе потребуется пароль")
              },
              {
                id: "min_price_control",
                label: tr("Минимальная цена продажи для товаров"),
                icon: CircleDollarSign,
                description:
                  tr("При включении для товара будет применяться минимальная цена продажи")
              },
              {
                id: "allow_custom_price",
                label: tr("Разрешить продажу с изменением цены"),
                icon: HandCoins,
                description:
                  tr("При включении можно продавать товар по измененной цене")
              },
              {
                id: "auto_print_receipt_after_payment ",
                label: tr(
                  "Автоматическая печать чека после оплаты"
                ),
                icon: Printer,
                description:
                  tr("При включении чек будет автоматически печататься после оплаты")
              },
              {
                id: "custom_total_sum_enabled",
                label: tr("Редактируемая общая сумма"),
                icon: Edit,
                description:
                  tr("При включении кассир сможет редактировать общую сумму заказа")
              },
              {
                id: "can_sell_for_debt",
                label: tr("Можно продать за долг"),
                icon: CreditCard,
                description:
                  tr("При включении можно оформлять продажу в долг")
              },
              {
                id: "show_photo",
                label: tr(
                  "Показывать фото товаров в приложении"
                ),
                icon: Image,
                description:
                  tr("При включении в приложении будут отображаться фото товаров")
              },
              {
                id: "show_waiter_order_history",
                label: tr(
                  "Показать историю заказов Агентам"
                ),
                icon: History,
                description:
                  tr("При включении Агенты смогут видеть историю заказов")
              },
              {
                id: "can_print_pre_check",
                label: tr("Вывод пречеков"),
                icon: Printer,
                description: tr("При включении этой функции вы можете выписать чек перед оплатой")
              },
              {
                id: "auto_create_sms_distribution",
                label: tr("Автоматическая отправка SMS"),
                icon: Printer,
                description: tr("При включении этой функции, клиенту совершившему покупку в долг, будет отправлено SMS-сообщение в установленное время")
              },
            ]
          }
        ].map(featureSection => {
          return (
            <div className="!mb-10">
              <p className="text-lg font-bold">
                {featureSection.title}
              </p>
              <div className="grid grid-cols-2 gap-5">
                {featureSection.children.map(feature => {
                  const isChecked = Boolean(
                    get(values, feature.id)
                  );
                  const Icon = feature.icon || Settings;

                  return (
                    <div
                      onClick={() => setFieldValue(feature.id, !isChecked)}
                      className={classNames({
                        "overflow-hidden tw-border select-none !border-gray-200 rounded-xl !p-5 w-full | flex items-center gap-3 relative cursor-pointer": true,
                        "!border-blue-700 bg-blue-50/50": isChecked
                      })}
                    >
                      <div className="absolute top-0 right-0 bg-gray-100 p-2 rounded-bl-xl">
                        <Fields.CheckboxD1
                          name={feature.id}
                          checked={isChecked}
                          position={"left"}
                          className="mb-0 pointer-events-none"
                        />
                      </div>
                      <div
                        className={classNames({
                          "size-16 flex-shrink-0 rounded-full | flex items-center justify-center bg-gray-50": true,
                          "!bg-blue-100 !text-blue-700": isChecked
                        })}
                      >
                        <Icon strokeWidth={1.25} />
                      </div>

                      <div className="space-y-2">
                        <p
                          className={classNames({
                            "text-base my-0 font- !pr-10": true,
                            "text-blue-500": isChecked
                          })}
                        >
                          {feature.label}
                        </p>
                        {feature.description ? (
                          <p className="text-sm my-0 text-gray-400">
                            {get(feature, "description")}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </>
    </div>
  )
}

export default OtherSetings